import React, { forwardRef } from 'react';

import { BoxProps, Flex, Box } from '@chakra-ui/react';

import { Button } from '../../../Button';
import { CartIcon } from '../../../Icons/CartIcon';
import { EColor } from '../../../Theme';
import { useMonolithUrls } from '../../hooks/useMonolithUrls';

interface ICartButtonProps extends BoxProps {
  count?: number;
  isBordered?: boolean;
}

export const CartButton = forwardRef<HTMLDivElement, ICartButtonProps>(
  ({ count = 0, isBordered = false, ...props }, ref) => {
    const { cartUrl } = useMonolithUrls();

    return (
      <Box
        ref={ref}
        {...props}
        aria-controls="cart-navigation"
        cursor="pointer"
        data-testid="nav-cart-button"
        ml={{ base: '0.5rem', md: undefined }}
        mr="2px"
        position="relative"
      >
        <Flex alignItems="center">
          <Button
            alignItems="center"
            backgroundColor="transparent"
            border={
              isBordered ? `1px solid ${EColor.Neutral150}` : 'transparent'
            }
            borderRadius={isBordered ? '50%' : '16px'}
            borderWidth="1px"
            display="flex"
            height={isBordered ? '36px' : '32px'}
            href={cartUrl}
            justifyContent="center"
            minWidth={isBordered ? '36px' : '32px'}
            padding={isBordered ? '10px' : '0'}
            position="relative"
            width={isBordered ? '36px' : '32px'}
          >
            <CartIcon
              height={isBordered ? '16px' : '20px'}
              width={isBordered ? '16px' : '20px'}
            />
            {count > 0 && (
              <Flex
                alignItems="center"
                backgroundColor="black"
                border="1px solid white"
                borderRadius="10px"
                color="white"
                fontSize="10px"
                fontWeight="bold"
                justifyContent="center"
                padding="3px 5px"
                position="absolute"
                right={isBordered ? '-5px' : '-1px'}
                top={isBordered ? '-5px' : '-2px'}
              >
                {count > 99 ? '99+' : count}
              </Flex>
            )}
          </Button>
        </Flex>
      </Box>
    );
  }
);
